import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Tcb from '../tcb'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '福州城投优采在线平台 - 首页'
    }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import(/* webpackChunkName: "agreement" */ '../views/Agreement.vue'),
    meta: {
      title: 'Agreement'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
    meta: {
      title: '福州城投优采在线平台 - 关于我们'
    }
  },
  {
    path: '/loginDetail',
    name: 'LoginDetail',
    component: () => import(/* webpackChunkName: "dspt" */ '../views/LoginDetail.vue'),
    meta: {
      title: '福州城投优采在线平台 - 供应商登陆'
    }
  },
  {
    path: '/deal',
    name: 'Deal',
    component: () => import(/* webpackChunkName: "deal" */ '../views/Deal.vue'),
    meta: {
      title: '福州城投优采在线平台 - 交易'
    }
  },
  {
    path: '/engineering',
    name: 'Engineering',
    component: () => import(/* webpackChunkName: "engineering" */ '../views/Engineering.vue'),
    meta: {
      title: '福州城投优采在线平台 - 招标大厅'
    }
  },
  {
    path: '/manual',
    name: 'Manual',
    component: () => import(/* webpackChunkName: "manual" */ '../views/Manual.vue'),
    meta: {
      title: '福州城投优采在线平台 - 业务指南'
    }
  },
  {
    path: '/logistics',
    name: 'Logistics',
    component: () => import(/* webpackChunkName: "logistics" */ '../views/Logistics.vue'),
    meta: {
      title: '福州城投优采在线平台 - 项目公告'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue'),
    children: [{
      path: '',
      name: 'NewsEntry',
      component: () => import(/* webpackChunkName: "news-entry" */'../components/News/Entry.vue'),
      meta: {
        title: '福州城投优采在线平台 - 新闻咨询'
      }
    }, {
      path: ':id',
      name: 'NewsDetail',
      props: true,
      component: () => import(/* webpackChunkName: "news-detail" */ '../components/News/Detail.vue')
    }]
  },
  {
    path: '/regulator',
    name: 'Regulator',
    component: () => import(/* webpackChunkName: "regulator" */ '../views/Regulator.vue'),
    meta: {
      title: '福州城投优采在线平台 - 监督机构'
    }
  },
  {
    path: '/big-data',
    name: 'BigData',
    component: () => import(/* webpackChunkName: "service" */ '../views/BigData.vue'),
    meta: {
      title: '福州城投优采在线平台 - 数据分析'
    }
  },
  {
    path: '/policy-statute',
    name: 'PolicyStatute',
    component: () => import(/* webpackChunkName: "policy-statute" */ '../views/PolicyStatute.vue'),
    children: [{
      path: '',
      name: 'PolicyStatuteEntry',
      component: () => import(/* webpackChunkName: "policy-statute-entry" */'../components/PolicyStatute/Entry.vue'),
      meta: {
        title: '福州城投优采在线平台 - 政策法规'
      }
    }, {
      path: ':id',
      name: 'PolicyStatuteDetail',
      props: true,
      component: () => import(/* webpackChunkName: "policy-statute-detail" */'../components/PolicyStatute/Detail.vue')
    }]
  },
  {
    path: '/shop',
    component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue'),
    meta: {
      title: '福州城投优采在线平台 - 网上超市'
    }
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
    meta: {
      title: '福州城投优采在线平台 - 404'
    }
  }
]

const router = new VueRouter({
  base: process.env.NODE_ENV === 'production' ? '/' : '.',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach(async (to, from, next) => {
  try {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    // if (!from.name) {
    //   const auth = Tcb.auth()
    //   await auth.anonymousAuthProvider().signIn()
    //   // 匿名登录成功检测登录状态isAnonymous字段为true
    //   const loginState = await auth.getLoginState()
    //   console.log(loginState.isAnonymousAuth) // true
    // }
    next()
  } catch (error) {
    console.log(error)
  }
})
export default router
